import UserProfile from "classic/views/UserProfile.js";
import SubmissionsList from "classic/views/SubmissionsList.js";
import Triage from "classic/views/Triage.js";
import Management from "classic/views/Management";
import { lazy } from "react";
import { MEA_OPS_BASE_PATH } from "./meaOpsRoutes";

const dashboardRoutes = [
  [  
    {
      path: "/submissions",
      name: "Submissions",
      component: SubmissionsList,
      layout: "/user",
    },
    {
      path: "/claims",
      name: "Claims",
      component: SubmissionsList,
      layout: "/user",
    },
    {
      path: "/triage",
      name: "Triage",
      component: Triage,
      layout: "/user",
    },
    {
      path: "/profile",
      name: "User Profile",
      component: UserProfile,
      layout: "/user",
    }
  ],
  [
    {
      path: "/submissions",
      name: "Submissions",
      component: SubmissionsList,
      layout: "/user",
    },
    {
      path: "/claims",
      name: "Claims",
      component: SubmissionsList,
      layout: "/user",
    },
    {
      path: "/triage",
      name: "Triage",
      component: Triage,
      layout: "/user",
    },
     {
      path: "/management",
      name: "Management",
      component: Management,
      layout: "/user",
    },
    {
      path: "/profile",
      name: "User Profile",
      component: UserProfile,
      layout: "/user",
    },
    {
      separator: true
    },
  ]  
];

export const newuiRoutes = [
  {
    name: "Dashboard",
    path: "/home",
    component: lazy(() => import("newui/components/view/Home")),
    layout: "/user",
  },
  {
    name: "MEA Ops Unavailable",
    path: "/*",
    component: lazy(() =>
      import("newui/components/view/MeaOpsUnavailable")
    ),
    layout: MEA_OPS_BASE_PATH,
    alwaysEnabled: true,
  },
  {
    name: "Template View",
    path: "/template-view",
    component: lazy(() => import("newui/components/view/TemplateView")),
    layout: "/user",
  },
  {
    name: "Submissions",
    path: "/submission-summary",
    component: lazy(() => import("newui/components/view/Submissions")),
    layout: "/user",
  },
  {
    name: "SOV",
    path: "/home/ingest-my-data/schedule-of-values",
    component: lazy(() => import("newui/components/view/IngestMyData/SOV")),
    layout: "/user",
  },
  {
    name: "New Business Submission",
    path: "/home/ingest-my-data/new-business-submission",
    component: lazy(() =>
      import("newui/components/view/IngestMyData/NewBusinessSubmission")
    ),
    layout: "/user",
  },
  {
    name: "Reports",
    path: "/reports",
    component: lazy(() => import("newui/components/view/Reports")),
    layout: "/user",
  },
  {
    name: "Ingest",
    path: "/home/ingest-my-data",
    component: lazy(() => import("newui/components/view/Ingest")),
    layout: "/user",
  },
  {
    name: "Template View Preview",
    path: "/template-view/preview",
    component: lazy(() => import("newui/components/view/TemplatePreview")),
    layout: "/user",
  },
  {
    name: "Documents",
    path: "/documents",
    component: lazy(() => import("newui/components/view/Documents")),
    layout: "/user",
  },
  {
    name: "Review",
    path: "/review",
    component: lazy(() => import("newui/components/view/Products/Review")),
    layout: "/user",
  },
  {
    name: "Rules",
    path: "/rules",
    component: lazy(() => import("newui/components/view/Products/Rules")),
    layout: "/user",
  },
  {
    name: "Learn More",
    path: "/learn-more",
    component: lazy(() => import("newui/components/view/Others/Learnmore")),
    layout: "/user",
  },
  {
    name: "Contact Us",
    path: "/contact-us",
    component: lazy(() => import("newui/components/view/Others/ContactUs")),
    layout: "/user",
  },
  {
    name: "QA Tool",
    path: "/qa-tool",
    component: lazy(() => import("newui/components/view/QATool")),
    layout: "/user",
  },
  {
    name: "QA Tool Direct",
    path: "/submissions/qatool/:submissionIdentifier",
    component: lazy(() => import("newui/components/view/QATool")),
    layout: "/user",
  },
  {
    name : "Configure My Apis",
    path: "/home/configure-my-apis",
    component: lazy(() => import("newui/components/view/ConfigureMyApis")),
    layout: "/user",
  },
  {
    name: "Summarize My Data",
    path: "/home/summarize-my-data",
    component: lazy(() => import("newui/components/view/SummarizeMyData")),
    layout: "/user",
  }
];

export default dashboardRoutes;
